var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3 vue__filter-outer"},[_c('load-filters')],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-9 vue__items-container-outer"},[_c('div',{attrs:{"id":"vue__scrollto-container"}}),_vm._v(" "),_c('load-catalog')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }